import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import {
  Box,
  SimpleGrid,
  Button,
  Icon,
  FormControl,
  FormLabel,
  InputRightElement,
  Text,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  InputGroup,
  PinInput,
  PinInputField,
  Stack,
  VStack,
  Center,
  useDisclosure,
  useToast,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiArrowLeft } from "react-icons/fi";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import Card from "components/card/Card.js";

export default function ChangePassword() {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const navigate = useNavigate();
  const {
    isOpen: isOtpOpen,
    onOpen: onOtpOpen,
    onClose: onOtpClose,
  } = useDisclosure();
  const [loading, setLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  //const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [pin1, setPin1] = useState("");
  const [pin2, setPin2] = useState("");
  const [pin3, setPin3] = useState("");
  const [pin4, setPin4] = useState("");
  const [pin5, setPin5] = useState("");
  const [pin6, setPin6] = useState("");
  const [otp, setOtp] = useState("");

  const [firstCode, setFirstCode] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0); // 60 seconds = 1 minute
  const [showResendLink, setShowResendLink] = useState(false);

  const userState = useSelector((state) => state?.user?.value);
  const token = userState.hasOwnProperty("token") ? userState.token : null;
  const toast = useToast();
  const textColorPrimary = useColorModeValue("secondaryGray.500", "white");
  const textColorSecondary = useColorModeValue("#000000", "#000000");
  const inputColor = useColorModeValue("brand.500", "gray.100");
  const backgroundColor = useColorModeValue("white", "brand.700");

  const changePassword = async () => {
    try {
      if (newPassword !== confirmNewPassword) {
        toast({
          title: "Passwords did not match, please check",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      setLoading(true);
      const { data: response } = await axios.post(
        SERVER_URL + "/user/changepassword",
        { newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.error || !response.success) {
        toast({
          id: response.error ? response.error : (response.message ? response.message : "api-error"),
          title: response.error ? response.error : (response.message ? response.message : "An error occured"),
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        toast({
          title: response.message,
          status: "success",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setLoading(false);
        setFirstCode(true);
        setRemainingTime(90);
        setShowResendLink(false);
        onOtpOpen();
        return;
      }
    } catch (error) {
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
      setLoading(false);
    }
  };

  const resetPassword = async () => {
    try {
      setResetLoading(true);
      setLoading(true);
      const { data: response } = await axios.post(
        SERVER_URL + "/user/resetpassword",
        { otp },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setResetLoading(false);
        setLoading(false);
        return;
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setResetLoading(false);
        setLoading(false);
        return;
      }
      if (response.success) {
        toast({
          title: response.message,
          status: "success",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        onOtpClose();
        setResetLoading(false);
        setLoading(false);
        navigate("/admin/settings/index");
      }
    } catch (error) {
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
      setResetLoading(false);
      setLoading(false);
    }
  };

  const getOtp = async () => {
    try {
      setLoading(true);
      const { data: response } = await axios.post(
        SERVER_URL + "/user/getOtp",
        { userId: userState._id },
        {
          headers: {},
        }
      );
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setLoading(false);
        return;
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setLoading(false);
        return;
      }
      if (response.success) {
        toast({
          title: response.message,
          status: "success",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setFirstCode(true);
        setRemainingTime(90);
        setShowResendLink(false);
      }
      setLoading(false);
    } catch (error) {
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
      setLoading(false);
      return;
    }
  };

  useEffect(() => {
    setOtp(pin1 + "" + pin2 + "" + pin3 + "" + pin4 + "" + pin5 + "" + pin6);
  }, [pin1, pin2, pin3, pin4, pin5, pin6, otp]);

  useEffect(() => {
    let timerId = null;
    if (remainingTime > 0) {
      timerId = setInterval(() => {
        setRemainingTime((prevTime) => prevTime - 1);
      }, 1000);
    } else {
      setShowResendLink(true);
    }
    return () => {
      clearInterval(timerId);
    };
  }, [remainingTime]);

  return (
    <>
      <Modal isOpen={isOtpOpen} onClose={onOtpClose} size={"md"}>
        <ModalOverlay />
        <ModalContent color={textColorSecondary} background={backgroundColor}>
          <ModalHeader color={textColorSecondary}>
            <Icon
              as={FiArrowLeft}
              onClick={onOtpClose}
              width="20px"
              height="20px"
              color={"#000000"}
            />
          </ModalHeader>
          <ModalCloseButton color={textColorSecondary} />
          <ModalBody>
            <SimpleGrid>
              <Box>
                <Heading
                  as="h5"
                  color={"#000000"}
                  size={{ base: "sm", lg: "md" }}
                >
                  Enter OTP Code Sent To Your Email
                </Heading>
              </Box>

              <Box>
                <VStack spacing={4} align="stretch">
                  <Box w="100%" minH="40px" mt="4" p="4" borderRadius={"10"}>
                    <Center width="100%">
                      <PinInput otp>
                        <PinInputField
                          w="45px"
                          h="45px"
                          color={"#000000"}
                          onChange={(e) => {
                            setPin1(e.target.value);
                          }}
                        />
                        <PinInputField
                          w="45px"
                          h="45px"
                          color={"#000000"}
                          onChange={(e) => {
                            setPin2(e.target.value);
                          }}
                        />
                        <PinInputField
                          w="45px"
                          h="45px"
                          color={"#000000"}
                          onChange={(e) => {
                            setPin3(e.target.value);
                          }}
                        />
                        <PinInputField
                          w="45px"
                          h="45px"
                          color={"#000000"}
                          onChange={(e) => {
                            setPin4(e.target.value);
                          }}
                        />
                        <PinInputField
                          w="45px"
                          h="45px"
                          color={"#000000"}
                          onChange={(e) => {
                            setPin5(e.target.value);
                          }}
                        />
                        <PinInputField
                          w="45px"
                          h="45px"
                          color={"#000000"}
                          onChange={(e) => {
                            setPin6(e.target.value);
                          }}
                        />
                      </PinInput>
                      {showResendLink ? (
                        firstCode ? (
                          <Button color={"#000000"} size="xs" onClick={getOtp}>
                            Send
                          </Button>
                        ) : (
                          <Button color={"#000000"} size="xs" onClick={getOtp}>
                            Send
                          </Button>
                        )
                      ) : (
                        <Text color={"#000000"}>&nbsp;{remainingTime}s </Text>
                      )}
                    </Center>
                  </Box>

                  <Box w="100%" minH="40px" mt="4" p="4">
                    <Button
                      fontSize="sm"
                      variant="brand"
                      fontWeight="500"
                      border={"1px solid black"}
                      color="#ffffff"
                      _hover={{ color: "brand.500", background: "#000000" }}
                      bgColor={"black"}
                      borderRadius={"2em"}
                      w="100%"
                      h="50"
                      isLoading={loading}
                      loadingText="Please Wait"
                      mb="24px"
                      onClick={(e) => {
                        e.preventDefault();
                        resetPassword();
                      }}
                    >
                      Proceed
                    </Button>
                  </Box>
                </VStack>
              </Box>
            </SimpleGrid>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>

      <Center width="100%">
      <Box mt={{ sm: "40px", md: "100px" }} width={{ sm: "90%", md: "50%" }} mb="20">
        <SimpleGrid
          columns={{ base: 1, sm: 1, md: 1, lg: 1 }}
          spacing="2"
          mb="3"
        >
          <Box textAlign="start">
            <Heading
              bg="inherit"
              fontWeight="bold"
              fontFamily="ManropeSemiBold"
              fontSize={{ base: "md", sm: "md", md: "lg", lg: "xl" }}
              mb="5"
            >
              Change Password
            </Heading>
          </Box>
          <Box textAlign="right">
          </Box>
        </SimpleGrid>

        <SimpleGrid columns={{ base: 1, sm: 1, md: 1, lg: 1 }}>
          <Stack spacing={4}>

            <FormControl id="password" isRequired>
              <FormLabel color={textColorSecondary} fontWeight="bold">
                New Password
              </FormLabel>
              <InputGroup>
                <Input
                  variant="main"
                  type={showPassword ? "text" : "password"}
                  maxLength={100}
                  placeholder="Enter New Password"
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                  }}
                />
                <InputRightElement h={"full"}>
                  <Button
                    variant={"ghost"}
                    color={"#000000"}
                    onClick={() =>
                      setShowPassword((showPassword) => !showPassword)
                    }
                  >
                    {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                  </Button>
                </InputRightElement>
              </InputGroup>
            </FormControl>

            <FormControl id="password" isRequired>
              <FormLabel color={textColorSecondary} fontWeight="bold">
                Confirm Password
              </FormLabel>
              <InputGroup>
                <Input
                  variant="main"
                  placeholder="Confirm New Password"
                  type={showPassword ? "text" : "password"}
                  maxLength={100}
                  onChange={(e) => {
                    setConfirmNewPassword(e.target.value);
                  }}
                />
                <InputRightElement h={"full"}>
                  <Button
                    variant={"ghost"}
                    color={"#000000"}
                    onClick={() =>
                      setShowPassword((showPassword) => !showPassword)
                    }
                  >
                    {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                  </Button>
                </InputRightElement>
              </InputGroup>
            </FormControl>

            <Button
              width="150px"
              variant="brand"
              isLoading={loading}
              loadingText="Wait"
              onClick={(e) => {
                e.preventDefault();
                changePassword();
              }}
            >
              Submit
            </Button>
          </Stack>
        </SimpleGrid>
      </Box>
      </Center>
    </>
  );
}

